@use "ui/styles/colors";
@use "ui/styles/sizes";
@use "ui/styles/effects";
@use "ui/styles/fonts";
@use "ui/styles/zindex";

.positioner {
    z-index: zindex.$tooltip;
}

.content {
    background: var(--tooltip-background-color, colors.$gray90);
    color: var(--tooltip-text-color, colors.$white);
    border-radius: effects.$borderRadiusS;
    padding: sizes.$s4 sizes.$s5;
    font-size: fonts.$mid;
    box-shadow: 0px 2px 8px 0px effects.$shadowColor;
    max-width: var(--tooltip-max-width, 250px);
    word-wrap: break-word;
    ul,
    ol {
        margin: 0;
        padding-left: sizes.$s6;
        padding-top: sizes.$s3;
        padding-bottom: sizes.$s3;
    }
    // Base UI exposes the anchored transform origin on the positioner; it inherits to the popup.
    transform-origin: var(--transform-origin);
    // Animation properties for enter/exit
    animation-duration: 200ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);

    // Direction-specific enter animations. Keyed on [data-open] (the persistent open state), not
    // [data-starting-style]: the latter lives for only a single frame — enough to kick off a CSS
    // transition, but it cancels a keyframe animation before it can play. The exit below uses
    // [data-ending-style], which Base UI keeps set for the whole close, so it plays fully.
    &[data-open] {
        animation-name: fadeInAndScale;

        &[data-side="top"] {
            animation-name: slideDownAndFade;
        }

        &[data-side="right"] {
            animation-name: slideLeftAndFade;
        }

        &[data-side="bottom"] {
            animation-name: slideUpAndFade;
        }

        &[data-side="left"] {
            animation-name: slideRightAndFade;
        }
    }

    // Exit animation (Base UI marks the leaving frame with data-ending-style).
    &[data-ending-style] {
        animation-name: fadeOutAndScale;
    }
}

// Base UI renders the arrow as a <div> (Radix used an <svg>), so draw the triangle with a
// rotated square that inherits the tooltip background color.
.arrow {
    // KEEP IN SYNC with TOOLTIP_ARROW_HEIGHT in Tooltip.tsx, which compensates the positioner
    // offset for the visible protrusion of this shape (10px square rotated 45deg, inset -3px).
    width: 10px;
    height: 10px;
    background: var(--tooltip-background-color, colors.$gray90);
    transform: rotate(45deg);

    &[data-side="top"] {
        bottom: -3px;
    }

    &[data-side="bottom"] {
        top: -3px;
    }

    &[data-side="left"] {
        right: -3px;
    }

    &[data-side="right"] {
        left: -3px;
    }
}

// Animation keyframes
@keyframes fadeInAndScale {
    from {
        opacity: 0;
        transform: scale(0.96);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes fadeOutAndScale {
    from {
        opacity: 1;
        transform: scale(1);
    }

    to {
        opacity: 0;
        transform: scale(0.96);
    }
}

@keyframes slideUpAndFade {
    from {
        opacity: 0;
        transform: translateY(2px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes slideRightAndFade {
    from {
        opacity: 0;
        transform: translateX(-2px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
}

@keyframes slideDownAndFade {
    from {
        opacity: 0;
        transform: translateY(-2px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes slideLeftAndFade {
    from {
        opacity: 0;
        transform: translateX(2px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
}
